// Gate select options: a stable id (what the form posts, D1 stores and HubSpot's
// pb_role / pb_account_count enumerations hold) beside the deck label the visitor sees.
// scripts/create-hubspot-properties.ts builds its enumeration options from these lists.

import { GATE_COPY } from "./copy";

export const ROLE_IDS = [
  "social_media_manager",
  "marketing_manager",
  "head_of_marketing",
  "agency_lead",
  "founder",
  "content_creator",
  "other",
] as const;
export type RoleId = (typeof ROLE_IDS)[number];

export const ACCOUNT_COUNT_IDS = ["1_3", "4_10", "11_25", "26_50", "50_plus"] as const;
export type AccountCountId = (typeof ACCOUNT_COUNT_IDS)[number];

export interface GateOption<Id extends string> {
  id: Id;
  label: string;
}

export const ROLE_OPTIONS: ReadonlyArray<GateOption<RoleId>> = ROLE_IDS.map((id, i) => ({
  id,
  label: GATE_COPY.roles[i],
}));

export const ACCOUNT_COUNT_OPTIONS: ReadonlyArray<GateOption<AccountCountId>> =
  ACCOUNT_COUNT_IDS.map((id, i) => ({ id, label: GATE_COPY.accounts[i] }));

export function isRoleId(value: unknown): value is RoleId {
  return typeof value === "string" && (ROLE_IDS as readonly string[]).includes(value);
}

export function isAccountCountId(value: unknown): value is AccountCountId {
  return typeof value === "string" && (ACCOUNT_COUNT_IDS as readonly string[]).includes(value);
}

export function roleLabel(id: string): string {
  return ROLE_OPTIONS.find((o) => o.id === id)?.label ?? id;
}

export function accountCountLabel(id: string): string {
  return ACCOUNT_COUNT_OPTIONS.find((o) => o.id === id)?.label ?? id;
}
